// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ProjectUser } from "./ProjectUser";
import {
  ProjectUserFromJSON,
  ProjectUserFromJSONTyped,
  ProjectUserToJSON,
  ProjectUserToJSONTyped,
} from "./ProjectUser";

/**
 *
 * @export
 * @interface PageProjectUser
 */
export interface PageProjectUser {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<ProjectUser>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageProjectUser interface.
 */
export function instanceOfPageProjectUser(value: object): value is PageProjectUser {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageProjectUserFromJSON(json: any): PageProjectUser {
  return PageProjectUserFromJSONTyped(json, false);
}

export function PageProjectUserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageProjectUser {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(ProjectUserFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageProjectUserToJSON(json: any): PageProjectUser {
  return PageProjectUserToJSONTyped(json, false);
}

export function PageProjectUserToJSONTyped(
  value?: PageProjectUser | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(ProjectUserToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
